import { call, put, takeLatest } from "redux-saga/effects";
import {
  fetchTerritorialChallengesRequest,
  fetchTerritorialChallengesSuccess,
  fetchTerritorialChallengesFailure,
  saveTerritorialChallengesRequest,
  saveTerritorialChallengesSuccess,
  saveTerritorialChallengesFailure,
  createSingleTerritorialChallengeRequest,
  createSingleTerritorialChallengeSuccess,
  createSingleTerritorialChallengeFailure,
  updateTerritorialChallengeRequest,
  updateTerritorialChallengeSuccess,
  updateTerritorialChallengeFailure,
  deleteTerritorialChallengeRequest,
  deleteTerritorialChallengeSuccess,
  deleteTerritorialChallengeFailure,
} from "./territorialChallengesSlice";
import { fastApiURL } from "../../utils/config";
import TokenManager from "../../utils/tokenManager"; 


function* fetchTerritorialChallengesSaga(action) {
  try {
    const { projectId } = action.payload;
    const token = TokenManager.getAccessToken(); 
    if (!token) throw new Error("Not authenticated");

    const response = yield call(fetch, `${fastApiURL}/api/projects/${projectId}/territorial-challenges`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`, 
      },
    });

    if (!response.ok) throw new Error("Failed to fetch territorial challenges");

    const data = yield response.json();
    yield put(fetchTerritorialChallengesSuccess(data));
  } catch (error) {
    console.error("Error in fetchTerritorialChallengesSaga:", error);
    yield put(fetchTerritorialChallengesFailure(error.message));
  }
}

function* saveTerritorialChallengesSaga(action) {
  try {
    const { projectId, territorial_challenges } = action.payload;
    const token = TokenManager.getAccessToken(); 
    if (!token) throw new Error("Not authenticated");

    const response = yield call(fetch, `${fastApiURL}/api/projects/${projectId}/territorial-challenges`, {
      method: "POST", // Bulk create endpoint
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`, 
      },
      body: JSON.stringify({ territorial_challenges }),
    });

    if (!response.ok) throw new Error("Failed to save territorial challenges");

    const data = yield response.json();
    yield put(saveTerritorialChallengesSuccess(data));
  } catch (error) {
    console.error("Error in saveTerritorialChallengesSaga:", error);
    yield put(saveTerritorialChallengesFailure(error.message));
  }
}

function* createSingleTerritorialChallengeSaga(action) {
  try {
    const { projectId, challenge } = action.payload;
    const token = TokenManager.getAccessToken(); 
    if (!token) throw new Error("Not authenticated");

    const response = yield call(fetch, `${fastApiURL}/api/projects/${projectId}/territorial-challenges/single`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`, 
      },
      body: JSON.stringify(challenge),
    });

    if (!response.ok) throw new Error("Failed to create territorial challenge");

    const data = yield response.json();
    yield put(createSingleTerritorialChallengeSuccess(data));
  } catch (error) {
    console.error("Error in createSingleTerritorialChallengeSaga:", error);
    yield put(createSingleTerritorialChallengeFailure(error.message));
  }
}

function* updateTerritorialChallengeSaga(action) {
  try {
    const { projectId, challengeId, challenge } = action.payload;
    const token = TokenManager.getAccessToken(); 
    if (!token) throw new Error("Not authenticated");

    const response = yield call(fetch, `${fastApiURL}/api/projects/${projectId}/territorial-challenges/${challengeId}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`, 
      },
      body: JSON.stringify(challenge),
    });

    if (!response.ok) throw new Error("Failed to update territorial challenge");

    const data = yield response.json();
    yield put(updateTerritorialChallengeSuccess(data));
  } catch (error) {
    console.error("Error in updateTerritorialChallengeSaga:", error);
    yield put(updateTerritorialChallengeFailure(error.message));
  }
}

function* deleteTerritorialChallengeSaga(action) {
  try {
    const { projectId, challengeId } = action.payload;
    const token = TokenManager.getAccessToken(); 
    if (!token) throw new Error("Not authenticated");

    const response = yield call(fetch, `${fastApiURL}/api/projects/${projectId}/territorial-challenges/${challengeId}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`, 
      },
    });

    if (!response.ok) throw new Error("Failed to delete territorial challenge");

    yield put(deleteTerritorialChallengeSuccess(challengeId));
  } catch (error) {
    console.error("Error in deleteTerritorialChallengeSaga:", error);
    yield put(deleteTerritorialChallengeFailure(error.message));
  }
}

export function* watchTerritorialChallenges() {
  yield takeLatest(fetchTerritorialChallengesRequest.type, fetchTerritorialChallengesSaga);
  yield takeLatest(saveTerritorialChallengesRequest.type, saveTerritorialChallengesSaga);
  yield takeLatest(createSingleTerritorialChallengeRequest.type, createSingleTerritorialChallengeSaga);
  yield takeLatest(updateTerritorialChallengeRequest.type, updateTerritorialChallengeSaga);
  yield takeLatest(deleteTerritorialChallengeRequest.type, deleteTerritorialChallengeSaga);
}